import axios from "axios";
import { API_ADD_SLIDER_IMAGE, API_GET_SLIDERS_DATA, API_GET_SLIDER_TYPE_DATA, API_INSERT_SLIDER_DATA, API_TOGGLE_PRODUCT_SLIDER_PRODUCT, API_TOGGLE_SLIDER_DATA, API_UPDATE_SLIDER_DATA } from ".";

export const getSliderList = async (func, config) => {
    return axios.get(API_GET_SLIDERS_DATA, config).then(res => func(res.data.data));
}

export const getSliderTypeList = async (func, config, query) => {
    return axios.get(`${API_GET_SLIDER_TYPE_DATA}?slider_type=${query}`, config).then(res => func(res.data.data));
}

export const insertSliderData = async (data, config) => {
    return axios.post(API_INSERT_SLIDER_DATA, data, config).then((res) => res.data);
};

export const addSliderImage = async (data, config, func) => {
    return axios.post(API_ADD_SLIDER_IMAGE, data, config).then((res) => res.data);
};

export const updateSliderData = async (data, config) => {
    return axios.put(API_UPDATE_SLIDER_DATA, data, config).then((res) => res.data);
};

export const toggleSliderData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_SLIDER_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};

export const toggleProductSliderproduct = async (data, config, cb) => {
    return axios.put(API_TOGGLE_PRODUCT_SLIDER_PRODUCT, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};